import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { WwwDirectusService } from 'www-cms';

export const contactUsContentResolver: ResolveFn<any> = (route, state) => {
  return inject(WwwDirectusService).getContactUsContent();
};
